import './loader.scss';

const SkeletonLoader = () => {
  const arr = Array.from({ length: 7 });
  return arr.map((item, index) => (
    <div key={index} className="skeleton-empty-card" />
  ));
};

export default SkeletonLoader;
